import React from 'react'
import TranslatableText from '@components/translations/TranslatableText'
import { TranslationKey } from '@typedefs/modulesInterfaces'

const ProjectDescriptionSubtitle = ({translationKey}: {translationKey: TranslationKey}) => {
  return (
    <p className="fs-12 mt-1">
        <TranslatableText translationKey={translationKey} />
    </p>
  )
}

export default ProjectDescriptionSubtitle